import dayjs from 'dayjs';
import localeRu from 'dayjs/locale/ru';
import duration from 'dayjs/plugin/duration';
import isoWeekDay from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeekDay);
dayjs.extend(duration);
dayjs.locale(localeRu);

export { dayjs as dateFormatter };
export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const DATE_TIME_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export type Dayjs = dayjs.Dayjs;
export type ConfigType = dayjs.ConfigType;
